





















































	import Vue from "vue";
	import Component from "vue-class-component";
	import TaskItem from "@/components/TaskItem.vue";
	import AddTaskButton from "@/components/AddTaskButton.vue";
	import dayjs from 'dayjs';
	import Task from '@/lib/Task';
	import TodoLogPageReq from '@/lib/TodoLogPageReq';
	import TodoLog from '@/lib/TodoLog';

	@Component({
		components: { TaskItem, AddTaskButton }
	})
	export default class Today extends Vue {
		// 无限滚动：https://www.yii666.com/blog/516192.html
		todayString = dayjs(new Date()).format("YYYY年MM月DD日");

		isEditing = false;
		editingTaskId = "-1";
		isAdding = false;

		showFinished = false;

		// 表示正在请求接口加载数据
		// loadPage = true;
		// 表示还有数据可以加载
		// loadMore = true;

		// tableData = [{
		// 	createTime: "2018/4/12",
		// 	type: "普通",
		// 	person: "黄公子",
		// 	content: "小小意思，提前完成1",
		// }, {
		// 	createTime: "2018/4/12",
		// 	type: "普通",
		// 	person: "黄公子",
		// 	content: "小小意思，提前完成2",
		// }];
		pagination = { pageSize: 10, current: 1};

		get task_list() : Task[] {
			const task_list = (this.$store.state.taskList || []) as Task[];
			return task_list.filter((task) => {
				if (task.due_date !== null) {
					if (dayjs(task.due_date).isSame(dayjs(new Date()), "day") && task.status !== 0) {
						return true;
					} else {
						return false;
					}
				}
				return false;
			});
		}

		get overdue_list() : Task[] {
			const task_list = (this.$store.state.taskList || []) as Task[];
			return task_list.filter((task) => {
				if (task.due_date !== null) {
					if (dayjs(task.due_date).isBefore(dayjs(new Date()), "day") && task.status === 1) {
						return true;
					} else {
						return false;
					}
				}
				return false;
			});
		}

		get tableData():TodoLog[] {
            return (this.$store.state.todoLogList as TodoLog[]);
        }

		get loadPage():boolean {
			return this.$store.state.todoLogPageLoading;
		}

		get loadMore():boolean {
			return this.$store.state.todoLogPageloadMore;
		}

		created() : void {
			this.$store.commit("fetchTaskList");
		}

		editTask(taskId : string) : void {
			this.editingTaskId = taskId;
			this.isEditing = true;
		}

		fnLoadMore() : void {
			console.log("请求加载更多...");
			if (this.loadMore) {
				this.filterSearch(this.pagination.current);
				this.pagination.current++
			}
		}

		// 查询记录列表
		filterSearch(page : number) : void {
			if (page != undefined && page >= 1) {
				this.pagination.current = page;
			}

			const pageReq = {
				current: this.pagination.current,
				size: this.pagination.pageSize
			} as TodoLogPageReq;

			this.$store.commit("fetchTodoLogPage", pageReq);
		}

		formatDateTime(datetime: string): string {
			return dayjs(datetime).format('YYYY年MM月DD日 HH:mm:ss');
		}

		formatDate(datetime: string): string {
			return dayjs(datetime).format('YYYY年MM月DD日');
		}

		formatTime(datetime: string): string {
			return dayjs(datetime).format('HH:mm:ss');
		}


		get getLoadPage() : boolean {
			return this.loadMore;
		}

	}
